<header class="background-header">
    <img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
        [ngClass]="{backgroundWidth: themeService.theme == 'white-label' || themeService.theme == 'life-file'}">
</header>

<section class="main-side-nav"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme == 'white-label' || themeService.theme == 'life-file'}">
    <section class="invite-only-container container">
        <ng-container *ngIf="displayReviewForCreateAccount == false">
            <app-steps-header *ngIf="createAccount==false" [step1]="'Add Client'" [step2]="'Add Message'"
                [step3]="'Preview &amp; Send'" [isStep1Active]="true" [isStep2Active]="false" [isStep3Active]="false">
            </app-steps-header>
            <app-steps-header *ngIf="createAccount==true" [step1]="'Add Client'" [step2]="'Review'" [step3]="'Create'"
                [isStep1Active]="true" [isStep2Active]="false" [isStep3Active]="false">
            </app-steps-header>
        </ng-container>
        <ng-container *ngIf="displayReviewForCreateAccount == true">
            <app-steps-header *ngIf="createAccount==true" [step1]="'Add Client'" [step2]="'Review'" [step3]="'Create'"
                [isStep1Active]="true" [isStep2Active]="true" [isStep3Active]="false">
            </app-steps-header>
        </ng-container>
        <section class="template-section-title">
            <div class="title-container">
                <h1>Zenplans Professional</h1>
            </div>
        </section>

        <section class="dynamic-collapse">
            <section class="dynamic-collapse-header invite-container">

                <h1 *ngIf="displayReviewForCreateAccount == false" class="col">Add an individual client</h1>
                <h1 *ngIf="displayReviewForCreateAccount == true" class="col">Review your client</h1>
            </section>
            <section class="dynamic-collapse-main">
                <div class="dynamic-collapse-content">
                    <ng-container *ngIf="displayReviewForCreateAccount==false">
                        <div class="form">
                            <div class="form-group">
                                <div class="form-field">
                                    <input type="text" placeholder="First Name" [(ngModel)]="firstName" name="firstName">
                                </div>
                                <div class="form-field">
                                    <input type="text" placeholder="Last Name" [(ngModel)]="lastName" name="lastName">
                                </div>
                                <div class="form-field">
                                    <input type="text" placeholder="Email Address" [(ngModel)]="email" name="email">
                                </div>
                                <div class="form-field">
                                    <input type="text" placeholder="Confirm Email Address" [(ngModel)]="confirmEmail"
                                        name="confirmEmail">
                                </div>
                            </div>
                            <div *ngIf="message" class="is-invalid">{{message}}</div>
                            <div class="form-actions">
                                <input type="button" value="Continue" class="next-step" (click)="saveForm()">
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="displayReviewForCreateAccount==true">
                        <div class="clients-uploaded">
                            <header class="header">
                                <!-- <div class="title">
                                    <span class="clients-length">{{response.length}} </span>
                                    <span>client<span *ngIf="response.length > 1">s</span> uploaded</span>
                                </div> -->
                                <div class="continue">
                                    <input type="button" value="Create Account" class="continue-btn" (click)="createUser()">
                                </div>
                            </header>
                            <form #emailForm="ngForm">
                                <table *ngIf="response && response.length > 0" class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Email</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let row of response; let i = index">
                                            <td *ngIf="editingRowIndex !== i">{{ row.data.firstName }}</td>
                                            <td class="edited-cell" *ngIf="editingRowIndex === i">
                                                <input class="edited-input" [(ngModel)]="row.data.firstName"
                                                    name="first_name_{{i}}" required />
                                            </td>
                                            <td *ngIf="editingRowIndex !== i">{{ row.data.lastName }}</td>
                                            <td class="edited-cell" *ngIf="editingRowIndex === i">
                                                <input class="edited-input" [(ngModel)]="row.data.lastName"
                                                    name="last_name_{{i}}" required />
                                            </td>
                                            <td *ngIf="editingRowIndex !== i"
                                                [class.invalid]="invalidEmails.includes(i)">{{ row.data.email }}</td>
                                            <td class="edited-cell" *ngIf="editingRowIndex === i">
                                                <input class="edited-input" [(ngModel)]="row.data.email"
                                                    name="email_{{i}}" #emailInput="ngModel"
                                                    [class.invalid]="invalidEmails.includes(i)" required email />

                                            </td>
                                            <td class="modif-buttons-container"
                                                [ngClass]="{ 'edited-cell': editingRowIndex === i }">
                                                <button class="modif-button" *ngIf="editingRowIndex !== i"
                                                    (click)="editRow(i)">Edit</button>
                                                <button class="modif-button" *ngIf="editingRowIndex === i"
                                                    (click)="saveRow(i, emailForm)">Save</button>
                                                <button class="modif-button" *ngIf="editingRowIndex === i"
                                                    (click)="cancelEdit()">Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </form>
                        </div>
                    </ng-container>
                </div>
            </section>
        </section>
    </section>
</section>